export const env = {
  service_url: process.env.REACT_APP_SERVICE_URL,
  export_url: process.env.REACT_APP_EXPORT_URL,
  socket_io_url: process.env.REACT_APP_SOCKET_IO_URL,
  socket_io_path: process.env.REACT_APP_SOCKET_IO_PATH,
  image_url: process.env.REACT_APP_IMAGE_URL,
}